import React, { useRef, useEffect } from 'react';
import './services.css';
import buffet from '../../assets/buffet.jpg';  /* SWAP_IMAGE */
import jacuzzi from '../../assets/jacuzzi.jpg'; /* SWAP_IMAGE */
import spa from '../../assets/spa.jpg';         /* SWAP_IMAGE */
import bdsm from '../../assets/bdsm.png';       /* SWAP_IMAGE */

const slides = [
    {
        img: buffet,
        title: 'Gourmet Buffet',
        desc: 'Unlimited drinks & food. Savor every moment.',
    },
    {
        img: jacuzzi,
        title: 'Jacuzzi',
        desc: 'Warm water. Total relaxation. Pure intimacy.',
    },
    {
        img: spa,
        title: 'Spa',
        desc: 'Complimentary massage. Melt into the evening.',
    },
    {
        img: bdsm,
        title: 'BDSM',
        desc: 'A discreet space for your boldest fantasies.',
    },
];

const Services = () => {
    const nextDom = useRef(null);
    const prevDom = useRef(null);
    const carouselDom = useRef(null);
    const listItemDom = useRef(null);
    const thumbnailDom = useRef(null);

    useEffect(() => {
        if (nextDom.current && prevDom.current && carouselDom.current && listItemDom.current && thumbnailDom.current) {
            nextDom.current.onclick = function () {
                showSlider('next');
            };
            prevDom.current.onclick = function () {
                showSlider('prev');
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let timeRunning = 3000;
    let timeAutoNext = 7000;
    let runTimeOut;
    let runAutoRun = setTimeout(() => {
        if (nextDom.current) {
            nextDom.current.click();
        }
    }, timeAutoNext);

    function showSlider(type) {
        const itemSlider = document.querySelectorAll('.carousel .list .item');
        const itemThumbnail = document.querySelectorAll('.carousel .thumbnail .item');

        if (type === 'next') {
            listItemDom.current.appendChild(itemSlider[0]);
            thumbnailDom.current.appendChild(itemThumbnail[0]);
            carouselDom.current.classList.add('next');
        } else {
            const positionLastItem = itemSlider.length - 1;
            listItemDom.current.prepend(itemSlider[positionLastItem]);
            thumbnailDom.current.prepend(itemThumbnail[positionLastItem]);
            carouselDom.current.classList.add('prev');
        }

        clearTimeout(runTimeOut);
        runTimeOut = setTimeout(() => {
            carouselDom.current.classList.remove('next');
            carouselDom.current.classList.remove('prev');
        }, timeRunning);

        clearTimeout(runAutoRun);
        runAutoRun = setTimeout(() => {
            if (nextDom.current) {
                nextDom.current.click();
            }
        }, timeAutoNext);
    }

    return (
        <section className='services fade-section' id='services'>
            <div className="services__header">
                <h2 className="services__title">Everything Included</h2>
                <p className="services__subtitle">One room. Four experiences.</p>
            </div>
            <div ref={carouselDom} className="carousel">
                <div ref={listItemDom} className="list">
                    {slides.map((slide, index) => (
                        <div className="item" key={index}>
                            <img src={slide.img} alt={slide.title} />
                            <div className="item__gradient"></div>
                            <div className="item__label">
                                <div className="item__label-title">{slide.title}</div>
                                <div className="item__label-desc">{slide.desc}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <div ref={thumbnailDom} className="thumbnail">
                    {/* Thumbnails order offset by 1 to match original carousel behavior */}
                    {[slides[1], slides[2], slides[3], slides[0]].map((slide, index) => (
                        <div className="item" key={index}>
                            <img src={slide.img} alt={slide.title} />
                        </div>
                    ))}
                </div>
                <div className="arrows">
                    <button id='prev' ref={prevDom} aria-label="Previous slide">{String.fromCharCode(60)}</button>
                    <button id='next' ref={nextDom} aria-label="Next slide">{String.fromCharCode(62)}</button>
                </div>
                <div className="time"></div>
            </div>
        </section>
    )
}

export default Services